import './conversion-controls.component.scss'
import {ConversionLogsSelectionOptions} from "../../model/ConversionLogsSelectionOptions";
import {ConversionLogControlsOptions} from "../../model/ConversionLogControlsOptions";
import {IController} from "angular";

export class ConversionControlsComponent implements IController {

    static instance = {
        template: require('./conversion-controls.component.html'),
        controller: [
            ConversionControlsComponent
        ],
        bindings: {
            selectionOptions: '<',
            conversionLogControlsOptions: '<'
        },
        controllerAs: '$ctrl'
    }

    private selectionOptions: ConversionLogsSelectionOptions;
    private conversionLogControlsOptions: ConversionLogControlsOptions;

}